import { Box, Grid, Paper, Typography } from '@material-ui/core'
import { components, constants, useTranslation, Yup } from 'cng-web-lib'
import { default as React } from 'react'
import Namespace from 'src/constants/locale/Namespace'
import SCOJobTranslationText from '../SCOJobTranslationText'
import { v4 as uuid } from 'uuid'

const {
    locale: {
        key: {
            CommonValidationMessageKeys,
        },
    },
} = constants
const { FormState } = constants
const {
    form: {
        field: { 
            CngSelectField,
            CngLookupAutocompleteField
        },
        adapter: {
            useFormAdapter: { useFormikContext }
        },
        CngForm
    },
    CngGridItem,
    CngDialog,
    button: { CngPrimaryButton, CngSecondaryButton }

} = components



const AttributeDialog = ({ reference, isOpen, setFieldValue, attributeList, setIsOpen, attrOptions, filteredAttrOptions, setNewFilteredOptions, index, taskList }) => {
    const { translate } = useTranslation(Namespace.SCO_JOB);

    const fieldsTranslatedTextObject = SCOJobTranslationText();
    const requiredMessage = translate(Namespace.COMMON_VALIDATION_MSG, CommonValidationMessageKeys.REQUIRED)
    const onSubmit = (values) => {
        let chosenAttrVal = values.chosenAttr;
        let chosenAttr = attrOptions.find(attr => attr.id == chosenAttrVal);
        if (reference === 'jobAttributeList') {
            const attrItem = {
                configDTO: chosenAttr,
                value: ""
            }
            const newList = [...attributeList, attrItem]
            setNewFilteredOptions(newList);
            setFieldValue("jobAttributeList", newList);
        } else {
            const attrItem = {
                configDTO: chosenAttr,
                value: "",
                idKey: uuid()
            }
            const list = [...taskList]
            const attrList = list[index].jobTaskAttributes
            const newList = [...attrList, attrItem];
            list[index].jobTaskAttributes = newList
            setFieldValue("jobTaskItems", list, true)
        }

        setIsOpen(false);
    };

    return (
        <CngDialog
            open={isOpen}
            fullWidth
            maxWidth='md'
            customDialogContent={
                <Paper>
                    <Box m={3} mt={3}>
                        <Typography variant="h5" className='font-bolder'>{fieldsTranslatedTextObject.scoSelectAttribute}</Typography>
                        <Box mt={2}>

                            <CngForm
                                formikProps={{
                                    initialValues: { chosenAttr: '' },
                                    validationSchema: Yup.object({ chosenAttr: Yup.string().required(requiredMessage) }),
                                    onSubmit: onSubmit
                                }}
                                formState={FormState.COMPLETED}
                                renderButtonSection={() => <></>}
                                renderBodySection={() =>
                                    <FormFields
                                        filteredAttrOptions={filteredAttrOptions}
                                        setIsOpen={setIsOpen}
                                        fieldsTranslatedTextObject={fieldsTranslatedTextObject}
                                    />
                                }
                            />

                        </Box>
                    </Box>
                </Paper>
            }

        />
    );
}


const FormFields = ({ filteredAttrOptions, setIsOpen, fieldsTranslatedTextObject }) => {
    const { submitForm } = useFormikContext()

    return (
        <Grid container alignItems='center' justify='center'>
            <CngGridItem xs={12}>
                <CngLookupAutocompleteField
                    label={fieldsTranslatedTextObject.scoAttribute}
                    name="chosenAttr"
                    options={filteredAttrOptions}
                    getOptionLabel={(option) => option.text}
                    required
                />
            </CngGridItem>
            <Box mt={2}>
                <CngPrimaryButton style={{ marginRight: '10px' }}
                    type="button"
                    onClick={submitForm}
                >
                    Add
                </CngPrimaryButton>
                <CngSecondaryButton
                    onClick={() => setIsOpen(false)}>
                    {"Cancel"}
                </CngSecondaryButton>
            </Box>
        </Grid>
    );
}


export default AttributeDialog;